// extracted by mini-css-extract-plugin
export var container = "_qt-0";
export var dotAnimation = "_qt-2";
export var dotsLoading = "_qt-1";